import { render, staticRenderFns } from "./WatchLive.vue?vue&type=template&id=96ca89e0"
import script from "./WatchLive.vue?vue&type=script&lang=js"
export * from "./WatchLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports